var DesktopBetCompany = function() {
    return {
        init: function() {
            $('#screenshots').Chocolat({
                imageSize: 'contain',
                loop: true,
                afterInitialize: function() {
                    $('.chocolat-wrapper').css('z-index', 1300);
                }
            });
        }
    };
}();
